<template>
  <div class="content">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>审核状态</span>
          <el-tag style="margin-left:10px">
            <template>
              {{ inventoryOrderStatus(userWithdrawalInfo.orderStatus) }}
            </template>
          </el-tag>
          <el-button v-show="(username == 'juzi001' || username == 'juzi002') && (userWithdrawalInfo.orderStatus==1 || userWithdrawalInfo.orderStatus==2)" style="margin-left:10px" type="primary" size="mini" icon="el-icon-edit" @click="auditClick">提交审核</el-button>
        </div> 
        <el-descriptions :column="4" border>
          <el-descriptions-item label="申请单号">{{userWithdrawalInfo.orderId}}</el-descriptions-item>
          <el-descriptions-item label="企业名称">{{userWithdrawalInfo.companyName}}</el-descriptions-item>
          <el-descriptions-item label="电话号码">{{userWithdrawalInfo.phone}}</el-descriptions-item>
          <el-descriptions-item label="申请人">{{userWithdrawalInfo.username}}</el-descriptions-item>
          <el-descriptions-item label="实际到账金额（元）">{{userWithdrawalInfo.actualAmount}}</el-descriptions-item>
          <el-descriptions-item label="手续费（元）">{{userWithdrawalInfo.serviceCharge}}</el-descriptions-item>
          <el-descriptions-item label="税金（元）">{{userWithdrawalInfo.taxMoney}}</el-descriptions-item>
          <el-descriptions-item label="提现金额（元）">{{userWithdrawalInfo.orderMoney}}</el-descriptions-item>
          <el-descriptions-item label="提现类型">
            <template>
              <el-tag size="small">{{ inventoryPayMode(userWithdrawalInfo.payMode) }}</el-tag>
            </template>
          </el-descriptions-item>
          <el-descriptions-item label="收款账号">
            <template>
              <el-tag size="medium" type="warning">{{userWithdrawalInfo.accountNumber}}</el-tag>
            </template>
          </el-descriptions-item>
          <el-descriptions-item label="收款姓名">
            <template>
              <el-tag size="medium" type="warning">{{userWithdrawalInfo.payeer}}</el-tag>
            </template>
          </el-descriptions-item>
          <el-descriptions-item label="申请时间">{{userWithdrawalInfo.orderTime}}</el-descriptions-item>
          <el-descriptions-item label="申请备注">{{userWithdrawalInfo.withdrawalRemark}}</el-descriptions-item>
          <el-descriptions-item label="审核时间">{{userWithdrawalInfo.auditTime}}</el-descriptions-item>
          <el-descriptions-item label="审核备注">{{userWithdrawalInfo.remark}}</el-descriptions-item>
          <el-descriptions-item label="结算时间段">{{userWithdrawalInfo.dateRange}}</el-descriptions-item>
          <el-descriptions-item v-if="adminShow" label="失败原因">{{ userWithdrawalInfo.errMsg}}</el-descriptions-item>
        </el-descriptions>
      </el-card>
      <el-card style="margin-top:5px">
        <div slot="header" class="clearfix">
          <span>提现金额明细</span>
          <el-button v-show="adminShow" style="margin-left:20px" type="primary" size="mini" icon="el-icon-edit" @click="withdrawalCommissionExportMethod">导出</el-button>
        </div>
        <el-table :data="withdrawalCommissionData" border style="width: 100%">
              <el-table-column fixed prop="orderNum" label="订单号" align="center" ></el-table-column>
              <el-table-column fixed prop="iccid" label="卡号" align="center" ></el-table-column>
              <el-table-column fixed prop="companyName" label="下级代理商名称" align="center" ></el-table-column>
              <el-table-column fixed prop="createTime" label="创建时间" align="center" width="180"></el-table-column>
              <el-table-column fixed prop="realPayAmount" label="订单金额" align="center"></el-table-column>
              <el-table-column fixed prop="totalRebateAmount" label="总分润" align="center"></el-table-column>
              <el-table-column fixed prop="realRebateAmount" label="实分润" align="center"></el-table-column>
              <el-table-column fixed prop="subRealRebateAmount" label="下级分润" align="center"></el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleWithdrawableSizeChange"
          @current-change="handleWithdrawableCurrentChange"
          :current-page="withdrawablePage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="withdrawablePageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalWithdrawable"
        ></el-pagination>
      </el-card>
      <!-- 弹框审核操作 -->
      <el-dialog :title="title" :visible.sync="dialog" @close="dialogClose" :lock-scroll="false" width="700px" v-dialogDrag>
        <el-form :model="form" :rules="rules" ref="form">
          <el-form-item label="审核状态" prop="orderStatus" label-width="160px">
            <el-select v-model="form.orderStatus" placeholder="请选择状态" style="width:350px">
              <el-option label="审核通过" value="2"></el-option>
              <el-option label="拒绝" value="6"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="remark" label-width="160px">
            <el-input type="textarea"  v-model="form.remark" style="width:350px"></el-input>
          </el-form-item>
          <el-form-item style="text-align:center">
            <el-button type="primary" @click="cancelDialog">取消</el-button>
            <el-button type="success" @click="submitAudit">确认</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
  </div>
</template>
<script>
import {userWithdrawalDetail,withdrawalCommissionPage,withdrawalCommissionExport} from "@/api/api.js";
import {withdrawalAudit} from "@/api/api.js";//审核提交
export default {
  data() {
    return {
      id:'',
      userWithdrawalInfo:{},
      withdrawablePage:1,
      withdrawablePageSize:10,
      totalWithdrawable:0,
      withdrawalCommissionData:[],
      title:"提现审核",
      dialog:false,
      form:{
        withdrawalId:undefined,
        orderStatus:undefined,
        remark:undefined
      },
      rules:{
        orderStatus: [
            { required: true, message: '请选择审核状态', trigger: 'blur' },
          ]
      }
    };
  },
  methods: {
    //提现详情信息
    userWithdrawalDetailMethod(){
      let params ={
        id:this.id
      }
      userWithdrawalDetail(params).then(res=>{
          if(res.data.code==200){
              this.userWithdrawalInfo = res.data.data;
          }
      })
    },
    inventoryPayMode(status) {
      let obj = {
        1: "微信",
        2: "支付宝",
        3: "余额",
        4: "银行卡对公账户"
      };
      return obj[status];
    },
    inventoryOrderStatus(status) {
      let obj = {
        1: "待审核",
        2: "审核通过",
        3: "结算中",
        4: "结算成功",
        5: "结算失败",
        6: "拒绝"
      };
      return obj[status];
    },
    withdrawalCommissionPageMethod(){
        let params = {
          model: {
            withdrawalId : this.id
          },
          page: this.withdrawablePage,
          pageSize: this.withdrawablePageSize
        };
        withdrawalCommissionPage(params).then(res=>{
          if(res.data.code == 200){
              this.totalWithdrawable = res.data.data.total;
              this.withdrawalCommissionData = res.data.data.records;
          }
        })
    },
    withdrawalCommissionExportMethod(){
      let params ={
        withdrawalId : this.id
      }
      withdrawalCommissionExport(params).then(res=>{
          if(res.data.code == 200){
            this.$message({
              message: '导出成功，前往任务中心查看下载',
              type: 'success'
            });
          }else{
            this.$message.error(res.data.message);
          }
      });
    },
    handleWithdrawableSizeChange(pageSize) {
      this.withdrawablePageSize = pageSize;
      this.withdrawalCommissionPageMethod();
    },
    handleWithdrawableCurrentChange(page) {
      this.withdrawablePage = page;
      this.withdrawalCommissionPageMethod();
    },
    dialogClose(){
      this.dialog = false;
    },
    cancelDialog(){
      this.dialog = false;
    },
    auditClick(){
      this.dialog = true;
    },
    submitAudit(){
      this.$refs["form"].validate(valid => {
        if (valid) {
          withdrawalAudit(this.form).then(res=>{
              if(res.data.code==200){
                  this.dialog = false;
                  this.userWithdrawalDetailMethod();
              }else{
                  this.$message.error(res.data.message);
              }
          });
        }
      });
    }
  },
  computed: {
    adminShow : {
      get() {
          return this.$store.getters.user.userType =='1'
        }
    },
    username:{
      get() {
          return this.$store.getters.name
      }
    }
  },
  mounted() {
    
  },
  created() {
    this.id =  this.$route.params && this.$route.params.id;
    this.userWithdrawalDetailMethod();
    this.withdrawalCommissionPageMethod();
    this.form.withdrawalId = this.id;
  }
};
</script>
<style scoped lang="less">
  
</style>


